module.exports = __webpack_public_path__ + "img/9-14.e88d402a.jpg";